<template>
    <div class="kgk-user-delete-account">
        <h2 v-if="!insideModal">
            Konto löschen
        </h2>
        <p style="font-size:12px;text-align:left;">
            Dein Nutzername und deine E-Mail-Adresse werden gelöscht und durch zufällige Werte ersetzt.
            Deine bisherigen Läufe und Kilometer bleiben erhalten und werden weiterhin gezählt. Diese Aktion kann nicht rückgängig gemacht werden.
        </p>
        <form @submit.prevent="performDelete">
            <div class="kgk-form-row">
                Aktuelles Passwort
                <div class="kgk-input-group">
                    <input type="password" v-model="password" name="password">
                </div>
                <div v-if="showValidationErrors && !passwordRequiredValidation" class="kgk-form-validation-error-inline">Bitte gib dein Passwort ein, um dein Konto zu löschen.</div>
            </div>
            <div v-if="!insideModal" class="kgk-form-row">
                <button type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span class="button-text">Konto löschen</span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import user from '../../api/user';

    export default {
        name: 'UserDeleteAccountForm',
        props: {
            insideModal: {
                type: Boolean,
                default: false,
            },
            modalSaveTrigger: {
                type: Object,
                required: false
            },
        },
        data() {
            return {
                loading: false,
                password: '',
                showValidationErrors: false,
            }
        },
        computed: {
            passwordRequiredValidation() {
                return this.password.length > 0;
            },
        },
        methods: {
            performDelete() {
                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                if( !this.passwordRequiredValidation ) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigiere deine Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                this.$emit('loadingStarted');

                user.deleteAccount(
                    this,
                    this.password,
                    () => {
                        this.$emit('deleted');
                    },
                    e => {
                        if( e.response.status == 422 || typeof e.response.data.message !== 'undefined' ) {
                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        this.loading = false;
                        this.$emit('loadingEnded');
                    }
                );
            },
        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.performDelete();
            },
        },
    }
</script>
